import type {UserEmail, SmtpSettingsUpdateInputFieldInput} from 'nutshell-graphql-types';

export const SMTP_DEFAULTS = {
    hostname: '',
    port: '465',
    ssl: 'SSL',
    username: '',
    userEmailId: '',
    password: '',
} as const;

export function getSettingsFromUserEmail(userEmail: UserEmail): SmtpSettingsUpdateInputFieldInput {
    const settings = userEmail.smtpCredentials ? userEmail.smtpCredentials.settings : SMTP_DEFAULTS;

    return {
        hostname: settings.hostname,
        port: settings.port,
        ssl: settings.ssl,
        username: settings.username,
        password: settings.password,
        userEmailId: settings.password,
    };
}
